import React from 'react';
import { blankChoice,blankOption,optionLabel } from './buildChoices';

function OptionDetail({option,value,onChange,label,blockedRefs}) {
  if (option?.option_type==='choice') return <SourceChoiceEditor label={label} definition={option.choice}
    value={value.selection} onChange={selection => onChange({...value,selection})} blockedRefs={blockedRefs} />;
  if (option?.option_type==='multiple') return <div className="vd-build__nested">
    {option.items.map((item,index) => <OptionDetail key={index} option={item}
      label={`${label}, ${optionLabel(item)}`} value={value.selection?.[index] || blankOption(item,index)} blockedRefs={blockedRefs}
      onChange={row => { const selection=value.selection?.slice() || option.items.map(blankOption); selection[index]=row; onChange({...value,selection}); }} />)}
  </div>;
  return null;
}

export default function SourceChoiceEditor({label,definition,value,onChange,blockedRefs=[]}) {
  if (!definition || definition.from?.option_set_type!=='options_array') return <p role="alert">Choice definitions are unavailable. Reload this page.</p>;
  if (definition.choose===0) return null;
  const options=definition.from.options; const rows=value?.length===definition.choose ? value : blankChoice(definition);
  return <fieldset className="vd-build__choice"><legend>{label} — choose {definition.choose}</legend>
    {rows.map((row,slot) => <div key={slot} className="vd-build__choice-row">
      <label>{label}, choice {slot+1}
        <select aria-label={`${label}, choice ${slot+1}`} value={row.optionIndex ?? -1} onChange={event => {
          const index=Number(event.target.value); const next=rows.slice();
          next[slot]=index<0 ? {optionIndex:-1} : blankOption(options[index],index); onChange(next);
        }}>
          <option value={-1}>Choose an option</option>
          {options.map((option,index) => <option key={index} value={index}
            disabled={rows.some((selected,other) => other!==slot && selected.optionIndex===index) ||
              (option?.option_type==='reference' && blockedRefs.includes(option.item.index))}>
            {optionLabel(option)}
          </option>)}
        </select>
      </label>
      {options[row.optionIndex] && <OptionDetail option={options[row.optionIndex]} value={row}
        label={`${label}, choice ${slot+1}`} blockedRefs={blockedRefs}
        onChange={nextRow => { const next=rows.slice(); next[slot]=nextRow; onChange(next); }} />}
    </div>)}
  </fieldset>;
}
